import { Inject, Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpRequest} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({ providedIn: 'root'})
export class ReportsServiceService {

  constructor(private http: HttpClient,
              @Inject('BASE_URL') private baseUrl: string) { }

  getStatesLifeCycles() {
    return this.http.get<any[]>('/api/getStatesLifeCycles');
  }

  private overrideStateLifeCycles = new BehaviorSubject<any>(null);

  getStateLifeCyclesForOverride(){
    this.getStatesLifeCycles()
      .subscribe(
        result => {
          let lifeCycles = result.filter(f => {
            const val = parseInt(f['value'], 10);
            return val === 7 || val === 4 || val === 5 || val === 9 || val === 6 || val === 3;
          });
          this.overrideStateLifeCycles.next(lifeCycles);
        }, error => {
          throw error;
        }
      );
    return this.overrideStateLifeCycles;
  }

  getTimelineEvents(bpInstanceId) {
    return this.http.get<any>(`api/reports/getTimelineEvents/${bpInstanceId}`);
  }

  searchMultipleBusinessProcessInstancesHistory(filter) {
    return this.http.post<any>(`api/reports/searchMultipleBusinessProcessInstancesHistory`, filter);
  }

  getBusinessProcessInstanceByIdForReport(bpInstanceId) {
    return this.http.get<any>(`api/reports/getBusinessProcessInstanceByIdForReport/${bpInstanceId}`);
  }

  getInstanceSummaryReport(filter) {
    return this.http.post<any>('api/reports/getInstanceSummaryReport', filter);
  }

  getInstanceHistoryDetails(instanceId, executionOrder, version) {
    const requestData = { instanceId: instanceId, executionOrder: executionOrder, version: version };
    return this.http.post<any>('api/reports/getInstanceHistoryDetails', requestData);
  }

  getHtmlView(instanceId, viewId) {
    return this.http.get<any>(`api/reports/getHtmlView/${instanceId}/${viewId}`);
  }

  getPdfView(instanceId: number, viewId: number) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(`api/reports/getPdfView/${instanceId}/${viewId}`, { headers: headers, responseType: 'blob' });
  }

  getAttachmentsByInstance(instanceId) {
    return this.http.get<any>(`api/reports/getAttachments/${instanceId}`);
  }

  getAttachmentContent(attachmentId: number, attachmentName: string): Observable<HttpEvent<Blob>> {
    return this.http.request(new HttpRequest(
      'GET',
      `api/reports/getAttachmentContent/${attachmentId}?attachmentName=${attachmentName}`,
      null,
      {
        reportProgress: true,
        responseType: 'blob'
      }));
  }

  getInstanceHistoryPdf(instanceId: number, bpName: string, url: string, onlyCurrentHistory: boolean, offset: number): Observable<HttpEvent<Blob>> {
    const requestData = {
      businessProcessInstanceId: instanceId,
      businessProcessName: bpName,
      url: url,
      onlyCurrentHistory: onlyCurrentHistory,
      offset: offset
    };
    return this.http.request(new HttpRequest(
      'POST',
      `api/reports/getInstanceHistoryPdf`,
      requestData,
      {
        reportProgress: true,
        responseType: 'blob'
      }));
  }

  getInstanceOverrideReport(filter) {
    return this.http.post<any>(`api/reports/getInstanceOverrideReport`, filter);
  }

  getBusinessProcessInstanceTimesAndAmount(filter) {
    return this.http.post<any>('api/reports/getBusinessProcessInstanceTimesAndAmount', filter);
  }
}

